export default "__VITE_ASSET__e1205947__"